import { render, staticRenderFns } from "./kindsAdd.vue?vue&type=template&id=45b86670&scoped=true&"
import script from "./kindsAdd.vue?vue&type=script&lang=js&"
export * from "./kindsAdd.vue?vue&type=script&lang=js&"
import style0 from "./kindsAdd.vue?vue&type=style&index=0&id=45b86670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b86670",
  null
  
)

export default component.exports